import { ApiService } from '../../api/api-service';
import { BuildingWithTrusses } from '../../types';
import {
  StageConfigDef,
  TaskTrackerRequest,
  TaskTrackerResponse,
  TrussSpecificationResponse,
} from './types';

const SERVICE_ROOT = '/tasktracker';

export class WorkOrderTravelerService extends ApiService {
  async getTaskTrackersByOrder(orderId: number): Promise<TaskTrackerResponse[]> {
    return this.handleApiCall(
      () => this.client.get<TaskTrackerResponse[]>(`${SERVICE_ROOT}/order/${orderId}`),
      `Error fetching task trackers for order ${orderId}`
    );
  }

  async getTaskTrackersByTruss(trussId: number): Promise<TaskTrackerResponse[]> {
    return this.handleApiCall(
      () => this.client.get<TaskTrackerResponse[]>(`${SERVICE_ROOT}/truss/${trussId}`),
      `Error fetching task trackers for truss ${trussId}`
    );
  }

  async createTaskTracker(request: TaskTrackerRequest): Promise<TaskTrackerResponse> {
    return this.handleApiCall(
      () => this.client.post<TaskTrackerResponse>(SERVICE_ROOT, request),
      `Error creating task tracker for truss ${request.trussId}`
    );
  }

  async updateTaskTracker(id: number, request: TaskTrackerRequest): Promise<TaskTrackerResponse> {
    return this.handleApiCall(
      () => this.client.put<TaskTrackerResponse>(`${SERVICE_ROOT}/${id}`, request),
      `Error updating task tracker ${id}`
    );
  }

  async deleteTaskTracker(id: number): Promise<void> {
    return this.handleApiCall(
      () => this.client.delete(`${SERVICE_ROOT}/${id}`),
      `Error deleting task tracker ${id}`
    );
  }

  async getTrussSpecificationsForBuilding(
    buildingId: number
  ): Promise<TrussSpecificationResponse[]> {
    return this.handleApiCall(
      () =>
        this.client.get<TrussSpecificationResponse[]>(
          `/trussspecifications/building/${buildingId}`
        ),
      `Error fetching truss specifications for building ${buildingId}`
    );
  }

  async getAllBuildingsWithTrusses(buildingIds: number[]): Promise<BuildingWithTrusses[]> {
    const results = await Promise.all(
      buildingIds.map(id =>
        this.handleApiCall(
          () => this.client.get<BuildingWithTrusses>(`/order/buildings/${id}`),
          `Error fetching building ${id}`
        )
      )
    );
    return results;
  }

  async getManufacturerStageConfigs(manufacturerId: number): Promise<StageConfigDef[]> {
    return this.handleApiCall(
      () =>
        this.client.get<StageConfigDef[]>(`/manufacturer/${manufacturerId}/task-tracker-stages`),
      `Error fetching stage config for manufacturer ${manufacturerId}`
    );
  }
}
